var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import moment from "moment";
import { TYPES } from "../../inversify/types";
import { Container as ContainerWrapper } from "../../common/Container";
import { UserUsageReport } from "./UserUsageReport";
import { CompanyUsageReport } from "./CompanyUsageReport";
import { container } from "../../inversify/inversify.config";
import { Tabs, Tab, MuiThemeProvider, createTheme } from "@material-ui/core";
import { ExtensionColumnType, ExtensionClientUsageReport, } from "../../helpers/Domain/ViewModels/Extension/ExtensionModels";
import { ClientUsageReportParams } from "../../helpers/Domain/ViewModels/ClientUsageReportParams";
import { gePreviousMonthDate } from "../../common/Validation";
import { filterSalesForceId } from "../../common/helper";
import { getAdhocCompanies, getAllActiveTaxSoftware, getClientUsageReport, } from "../../services/Apis";
var excelUtilities = container.get(TYPES.IExcelUtilities);
export var UsageReportTab;
(function (UsageReportTab) {
    UsageReportTab[UsageReportTab["Company"] = 0] = "Company";
    UsageReportTab[UsageReportTab["User"] = 1] = "User";
})(UsageReportTab || (UsageReportTab = {}));
var theme = createTheme({
    palette: {
        primary: { main: "#4caf50" },
    },
});
var UsageReport = /** @class */ (function (_super) {
    __extends(UsageReport, _super);
    function UsageReport(props) {
        var _this_1 = _super.call(this, props) || this;
        _this_1.getClientUsageData = function (clientUsageReportParams) {
            var _self = _this_1;
            var selectedTaxSoftware = clientUsageReportParams.selectedTaxSoftware;
            var deliveryMode = clientUsageReportParams.deliveryMode;
            if (selectedTaxSoftware &&
                typeof selectedTaxSoftware === "object" &&
                selectedTaxSoftware.value) {
                selectedTaxSoftware = selectedTaxSoftware.value;
            }
            if (deliveryMode &&
                typeof deliveryMode === "object" &&
                deliveryMode.value) {
                deliveryMode = deliveryMode.value;
            }
            var fromDate = new Date(clientUsageReportParams.fromDate);
            var toDate = new Date(clientUsageReportParams.toDate);
            var queryString = "?fromDate=".concat(fromDate.toISOString(), "\n                           &toDate=").concat(toDate.toISOString(), "\n                           &selectedTaxSoftware=").concat(selectedTaxSoftware, "\n                           &groupBy=").concat(clientUsageReportParams.groupBy, "\n                           &deliveryMode=").concat(deliveryMode, "\n                           &companyId=").concat(clientUsageReportParams.companyId);
            getClientUsageReport(queryString).then(function (response) {
                response.data.forEach(function (value, index) {
                    value.Total1040 = value.E1040 + value.P1040;
                    value.Total1041 = value.E1041 + value.P1041;
                    value.Total1065 = value.E1065 + value.P1065;
                    value.Total1120 = value.E1120 + value.P1120;
                    value.Total1120S = value.E1120S + value.P1120S;
                    value.Total990 = value.E990 + value.P990;
                    value.Total990PF = value.E990PF + value.P990PF;
                    value.Total990EZ = value.E990EZ + value.P990EZ;
                });
                _self.setState({
                    rows: response.data,
                    filteredRows: response.data,
                    currentPage: 0,
                }, _self.getClientSideFilteredData);
            });
        };
        _this_1.setPaginatedResult = function () {
            var filtereddata = __spreadArray([], __read(_this_1.state.filteredRows), false);
            var temp = filtereddata.length;
            var _tempData = _this_1.getPaginatedResult(filtereddata);
            _this_1.setState({
                paginatedData: _this_1.addSummary(_tempData),
                totalCount: temp,
            });
        };
        _this_1.getPaginatedResult = function (data) {
            return data.splice(_this_1.state.currentPage * _this_1.state.pageSize, _this_1.state.pageSize);
        };
        _this_1.addSummary = function (tempData) {
            _this_1.addPageSummary(tempData);
            _this_1.addTableSummary(tempData);
            return tempData;
        };
        _this_1.addTableSummary = function (tempData) {
            tempData.push(_this_1.getSummaryData(_this_1.state.filteredRows, ExtensionColumnType.TableFooter));
            return tempData;
        };
        _this_1.getClientSideFilteredData = function () {
            var tempData = __spreadArray([], __read(_this_1.state.filteredRows), false);
            tempData = tempData.filter(function (data) {
                return data.UserName == null ? (data.UserName = " ") : data.UserName;
            });
            tempData = tempData.filter(function (data) {
                return data.UserEmail == null ? (data.UserEmail = " ") : data.UserEmail;
            });
            tempData = filterSalesForceId(tempData);
            tempData = tempData.filter(function (data) {
                return _this_1.state.selectedTab == UsageReportTab.User
                    ? (data.CompanyName = " ")
                    : data.CompanyName;
            });
            var tempCompanies = _this_1.filterCompanyDropDown(_this_1.state.companies);
            //Hide Test Account
            if (_this_1.state.hideTestAccount) {
                tempData = tempData.filter(function (item) {
                    if (!item.IsTestCompany)
                        return item;
                });
            }
            //Search
            tempData = tempData.filter(function (x) {
                return x.CompanyName.toLocaleLowerCase().includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.UserName.toLocaleLowerCase().includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.SalesforceId.toLocaleLowerCase().includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    moment(x.LastSend)
                        .format("MM/DD/YYYY")
                        .toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E1040.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P1040.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E1041.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P1041.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E1065.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P1065.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E1120.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P1120.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E1120S.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P1120S.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E990.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P990.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E990PF.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P990PF.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.E990EZ.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.P990EZ.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase()) ||
                    x.Total.toString()
                        .toLocaleLowerCase()
                        .includes(_this_1.state.searching.toLocaleLowerCase());
            });
            //Set State for custom Sort
            _this_1.setState({
                filteredRows: tempData,
                filteredCompanies: tempCompanies,
            }, function () {
                _this_1.changeSorting(_this_1.state.sorting);
            });
        };
        _this_1.addPageSummary = function (tempData) {
            tempData.push(_this_1.getSummaryData(tempData, ExtensionColumnType.PageFooter));
            return tempData;
        };
        _this_1.search = function (value) {
            _this_1.setState({
                filteredRows: _this_1.state.rows,
                searching: value,
                currentPage: 0,
            }, _this_1.getClientSideFilteredData);
        };
        _this_1.downloadAsPdf = function () {
            var excelData = [];
            var _this = _this_1;
            _this_1.state.filteredRows.forEach(function (row) {
                var rowObj = new Map();
                if (_this.state.selectedTab == UsageReportTab.User) {
                    rowObj.set("User Name", row.UserName);
                    rowObj.set("Email", row.UserEmail == null ? "" : row.UserEmail);
                }
                else {
                    rowObj.set("Company", row.CompanyName);
                }
                rowObj.set("Salesforce ID", row.SalesforceId == null || row.SalesforceId == " "
                    ? "-"
                    : row.SalesforceId);
                rowObj.set("Last Sent", new Date(row.LastSend + "Z").toLocaleDateString().replace(/\//g, "-"));
                rowObj.set("1040", row.Total1040);
                rowObj.set("1041", row.Total1041);
                rowObj.set("1065", row.Total1065);
                rowObj.set("1120", row.Total1120);
                rowObj.set("1120S", row.Total1120S);
                rowObj.set("990/T", row.Total990);
                rowObj.set("990PF", row.Total990PF);
                rowObj.set("990EZ", row.Total990EZ);
                rowObj.set("Total", row.Total);
                excelData.push(rowObj);
            });
            excelUtilities.DownloadUsingMap(excelData, "Usage Report", true);
        };
        _this_1.loadCompanies = function () {
            var _self = _this_1;
            getAdhocCompanies().then(function (response) {
                var tempCompanies = _self.filterCompanyDropDown(response.data);
                _self.setState({
                    companies: response.data,
                    selectedCompany: tempCompanies[0],
                    filteredCompanies: tempCompanies,
                });
            });
        };
        _this_1.filterCompanyDropDown = function (companies) {
            var tempCompanies = [];
            if (_this_1.state.hideTestAccount) {
                companies.map(function (compDetail) {
                    if (compDetail.IsTestCompany == false) {
                        var temp = {
                            value: compDetail.CompanyId,
                            label: compDetail.CompanyName,
                        };
                        tempCompanies.push(temp);
                    }
                });
            }
            else {
                companies.map(function (compDetail) {
                    var temp = {
                        value: compDetail.CompanyId,
                        label: compDetail.CompanyName,
                    };
                    tempCompanies.push(temp);
                });
            }
            return tempCompanies;
        };
        _this_1.handleCompanyChange = function (selectedValue) {
            _this_1.setState({ selectedCompany: selectedValue });
        };
        _this_1.handleTabChange = function () {
            var newTab = _this_1.state.selectedTab === UsageReportTab.Company
                ? UsageReportTab.User
                : UsageReportTab.Company;
            _this_1.setState({ selectedTab: newTab });
            _this_1.clearfilter();
        };
        _this_1.getSalesForceId = function () {
            var company = _this_1.state.companies.find(function (comp) { return comp.CompanyId == _this_1.state.selectedCompany.value; });
            return company && company.SalesForceId && company.SalesForceId.length > 0
                ? company.SalesForceId
                : "Not Available";
        };
        _this_1.createTabContent = function () {
            switch (_this_1.state.selectedTab) {
                case UsageReportTab.Company:
                    return (_jsx(CompanyUsageReport, { rows: _this_1.state.paginatedData, changeCurrentPage: _this_1.changeCurrentPage, changeSorting: _this_1.changeSorting, clearfilter: _this_1.clearfilter, countColumnsFormatter: _this_1.countColumnsFormatter, currentPage: _this_1.state.currentPage, downloadAsPdf: _this_1.downloadAsPdf, getClientUsageData: _this_1.getClientUsageData, handleDeliveryModeChange: _this_1.handleDeliveryModeChange, handleTaxSoftwareChange: _this_1.handleTaxSoftwareChange, hideTestCompanies: _this_1.hideTest, lastSentFormatter: _this_1.lastSentFormatter, pageSize: _this_1.state.pageSize, salesForceIDFormatter: _this_1.salesForceIDFormatter, search: _this_1.search, searching: _this_1.state.searching, selectedDeliveryMode: _this_1.state.selectedDeliveryMode, selectedTaxSoftware: _this_1.state.selectedTaxSoftware, taxSoftwareList: _this_1.state.taxSoftwareList, totalCount: _this_1.state.totalCount, sorting: _this_1.state.sorting }));
                case UsageReportTab.User:
                    return (_jsx(UserUsageReport, { rows: _this_1.state.paginatedData, changeCurrentPage: _this_1.changeCurrentPage, changeSorting: _this_1.changeSorting, clearfilter: _this_1.clearfilter, countColumnsFormatter: _this_1.countColumnsFormatter, currentPage: _this_1.state.currentPage, downloadAsPdf: _this_1.downloadAsPdf, getClientUsageData: _this_1.getClientUsageData, handleDeliveryModeChange: _this_1.handleDeliveryModeChange, handleTaxSoftwareChange: _this_1.handleTaxSoftwareChange, hideTestCompanies: _this_1.hideTest, lastSentFormatter: _this_1.lastSentFormatter, pageSize: _this_1.state.pageSize, salesForceIDFormatter: _this_1.salesForceIDFormatter, search: _this_1.search, searching: _this_1.state.searching, selectedDeliveryMode: _this_1.state.selectedDeliveryMode, selectedTaxSoftware: _this_1.state.selectedTaxSoftware, taxSoftwareList: _this_1.state.taxSoftwareList, totalCount: _this_1.state.totalCount, sorting: _this_1.state.sorting, companies: _this_1.state.filteredCompanies, selectedCompany: _this_1.state.selectedCompany, handleCompanyChange: _this_1.handleCompanyChange, salesForceId: _this_1.getSalesForceId() }));
            }
        };
        _this_1.clearfilter = function () {
            var sorting = _this_1.state.selectedTab === UsageReportTab.Company
                ? [{ columnName: "CompanyName", direction: "asc" }]
                : [{ columnName: "UserName", direction: "asc" }];
            var companyId = _this_1.state.selectedTab == UsageReportTab.Company
                ? 0
                : _this_1.state.filteredCompanies[0].value;
            var tempSelected = { value: -1, label: "All" };
            _this_1.setState({
                searching: "",
                currentPage: 0,
                sorting: sorting,
                selectedTaxSoftware: { value: -1, label: "All" },
                selectedDeliveryMode: { value: -1, label: "All" },
                selectedCompany: _this_1.state.filteredCompanies[0],
            }, function () {
                _this_1.getClientUsageData(new ClientUsageReportParams(gePreviousMonthDate(), new Date(), tempSelected.value, _this_1.state.selectedTab, tempSelected.value, companyId));
            });
        };
        _this_1.changeCurrentPage = function (page) {
            _this_1.setState({
                currentPage: page,
            }, _this_1.getClientSideFilteredData);
        };
        _this_1.changeSorting = function (sorting) {
            var _tempFilteredData = __spreadArray([], __read(_this_1.state.filteredRows), false);
            var _a = sorting[0], columnName = _a.columnName, direction = _a.direction;
            var inverse = direction === "desc";
            _tempFilteredData = _tempFilteredData.sort(function (a, b) {
                var result = 0;
                var columnA = columnName == "CompanyName" ||
                    columnName == "UserName" ||
                    columnName == "UserEmail"
                    ? a[columnName].toString().toLocaleLowerCase()
                    : a[columnName];
                var columnB = columnName == "CompanyName" ||
                    columnName == "UserName" ||
                    columnName == "UserEmail"
                    ? b[columnName].toString().toLocaleLowerCase()
                    : b[columnName];
                if (columnA < columnB)
                    result = -1;
                if (columnA > columnB)
                    result = 1;
                return inverse ? -result : result;
            });
            _this_1.setState({
                sorting: sorting,
                filteredRows: _tempFilteredData,
            }, _this_1.setPaginatedResult);
        };
        _this_1.hideTest = function (hideTest) {
            _this_1.setState({
                filteredRows: _this_1.state.rows,
                hideTestAccount: hideTest,
                currentPage: 0,
            }, _this_1.getClientSideFilteredData);
        };
        _this_1.handleTaxSoftwareChange = function (selectedTaxSoftware) {
            _this_1.setState({
                selectedTaxSoftware: selectedTaxSoftware,
            });
        };
        _this_1.handleDeliveryModeChange = function (selectedValue) {
            _this_1.setState({ selectedDeliveryMode: selectedValue });
        };
        _this_1.lastSentFormatter = function (row) {
            switch (row.row.ColumnType) {
                case ExtensionColumnType.PageFooter:
                    return _jsx("strong", { children: " " });
                case ExtensionColumnType.TableFooter:
                    return _jsx("strong", { children: " " });
                default:
                    return (_jsx("span", __assign({ title: "Last Sent" }, { children: moment(row.row.LastSend).format("MM/DD/YYYY").toLocaleString() })));
            }
        };
        _this_1.salesForceIDFormatter = function (row) {
            return (_jsx("span", __assign({ title: row.row.SalesforceId }, { children: row.row.SalesforceId == null || row.row.SalesforceId == " "
                    ? "Not Available"
                    : row.row.SalesforceId })));
        };
        _this_1.countColumnsFormatter = function (row) {
            switch (row.row.ColumnType) {
                case ExtensionColumnType.PageFooter:
                case ExtensionColumnType.TableFooter:
                    return _jsx("strong", __assign({ style: { fontSize: '13px' } }, { children: row.value }));
                default:
                    return _jsx("span", __assign({ title: row.value }, { children: row.value }));
            }
        };
        _this_1.getSummaryData = function (tempData, columnType) {
            var sum1040 = tempData.reduce(function (sum, row) {
                return sum + row.Total1040;
            }, 0);
            var sum1041 = tempData.reduce(function (sum, row) {
                return sum + row.Total1041;
            }, 0);
            var sum1065 = tempData.reduce(function (sum, row) {
                return sum + row.Total1065;
            }, 0);
            var sum1120 = tempData.reduce(function (sum, row) {
                return sum + row.Total1120;
            }, 0);
            var sum1120S = tempData.reduce(function (sum, row) {
                return sum + row.Total1120S;
            }, 0);
            var sum990 = tempData.reduce(function (sum, row) {
                return sum + row.Total990;
            }, 0);
            var sum990PF = tempData.reduce(function (sum, row) {
                return sum + row.Total990PF;
            }, 0);
            var sum990EZ = tempData.reduce(function (sum, row) {
                return sum + row.Total990EZ;
            }, 0);
            var totalSum = tempData.reduce(function (sum, row) {
                return sum + row.Total;
            }, 0);
            return new ExtensionClientUsageReport("", "", "", 0, 0, 0, 0, 0, sum1040, sum1041, sum1065, sum1120, sum1120S, totalSum, columnType, false, "", "", 0, 0, 0, sum990, sum990PF, sum990EZ);
        };
        _this_1.state = {
            selectedTab: UsageReportTab.Company,
            filteredRows: [],
            paginatedData: [],
            rows: [],
            taxSoftwareList: [],
            selectedTaxSoftware: {},
            selectedDeliveryMode: {},
            pageSize: 20,
            currentPage: 0,
            selection: [],
            searching: "",
            hideTestAccount: true,
            sorting: [{ columnName: "CompanyName", direction: "asc" }],
            companies: [],
            selectedCompany: {},
            filteredCompanies: [],
            totalCount: 0,
        };
        return _this_1;
    }
    UsageReport.prototype.componentDidMount = function () {
        var _this = this;
        var tempTaxSoftwareData = [{ value: -1, label: "All" }];
        var tempSelected = { value: -1, label: "All" };
        this.loadCompanies();
        getAllActiveTaxSoftware().then(function (response) {
            var taxSoftwareData = response.data;
            taxSoftwareData.map(function (taxSoftware) {
                tempTaxSoftwareData.push({
                    value: taxSoftware.Id,
                    label: taxSoftware.DisplayName,
                });
            });
            _this.setState({
                taxSoftwareList: tempTaxSoftwareData,
                selectedTaxSoftware: tempSelected,
                selectedDeliveryMode: tempSelected,
            });
        });
    };
    UsageReport.prototype.render = function () {
        return (_jsxs(MuiThemeProvider, __assign({ theme: theme }, { children: [_jsxs(Tabs, __assign({ style: { borderBottom: "1px solid #e8e8e8" }, value: this.state.selectedTab, onChange: this.handleTabChange, indicatorColor: "primary", textColor: "primary" }, { children: [_jsx(Tab, { label: "COMPANY", className: "tab-report-label" }), _jsx(Tab, { label: "USER", className: "tab-report-label" })] })), _jsx(ContainerWrapper, __assign({ visibility: true, title: "Usage Report" }, { children: this.createTabContent() }))] })));
    };
    return UsageReport;
}(React.Component));
export default UsageReport;
